module.exports = __webpack_public_path__ + "img/val-manage-hover.64f2940b.png";